import request from '@webtrader/core/request';
import { checkIsNative } from '@webtrader/core/validators/device';

import { ILoginParams, ILoginResponse } from './types';

const login = (params: ILoginParams) => {
  return checkIsNative()
    ? request.post<ILoginResponse>('/api/auth/v1/company/mobile/login', params)
    : request.post<ILoginResponse>('/api/auth/v1/company/login', params);
};

export default login;
